// 园区总览
const zl = {
    '$zl_menu_button_rain': '雨天',
    '$zl_menu_button_snow': '雪天',
    '$zl_menu_button_roamScene': '漫游',
    '$zl_menu_button_trafficIntersection': '路口监控',
    '$zl_menu_button_trafficVideo': '路口视频',
    '$zl_button_parkOverview': '园区总览',
    '$zl_button_parkPlanning': '园区规划',
    '$zl_button_parkConstruction': '园区建设',
    '$zl_button_parkInvestment': '园区招商',
    '$zl_button_parkOperation': '园区运营',
    '$zl_button_parkBuilding': '园区楼宇',
    '$zl_l1_title1': '园区总览',
    '$zl_l1_title2': 'Overview',
    '$zl_l1_n_area': '园区总面积',
    '$zl_l1_n_useArea': '园区总用地面积',
    '$zl_l1_n_people': '园区人数',
    '$zl_l1_n_entCount': '园区企业数',
    '$zl_l1_u_people': '人',
    '$zl_l1_u_entCount': '家',
    '$zl_l2_title1': '区域面积',
    '$zl_l2_title2': 'Area',
    '$zl_l2_n_name1': 'A区：',
    '$zl_l2_n_name2': 'B区：',
    '$zl_l2_n_name3': 'C区：',
    '$zl_l3_title1': '园区企业',
    '$zl_l3_title2': 'Enterprise',
    '$zl_l3_title3': '企业总数',
    '$zl_r1_title1': '园区信息',
    '$zl_r1_title2': 'Information',
    '$zl_r1_n_parkingCount': '剩余停车位',
    '$zl_r1_u_parkingCount': '个',
    '$zl_r1_n_peple': '园区人数',
    '$zl_r1_u_peple': '人',
    '$zl_r1_n_air': '空气质量',
    '$zl_r1_n_temperature': '园区气温',
    '$zl_r1_n_traffic': '园区交通',
    '$zl_r1_n_weather': '园区天气',
    '$zl_r2_title1': '园区事件',
    '$zl_r2_title2': 'Event',
}
// 园区规划
const gh = {
    '$gh_menu_button_dk': '地块规划',
    '$gh_menu_button_wg': '管网规划',
    '$gh_l1_title1': '园区规划',
    '$gh_l1_title2': 'Situation',
    '$gh_l1_name': 'A区',
    '$gh_l1_n_name': '区域规划',
    '$gh_l1_n_area': '规划总面积',
    '$gh_l1_n_building': '规划楼宇',
    '$gh_l1_u_building': '(栋)',
    '$gh_l1_n_busRoutes': '规划公交线路数',
    '$gh_l1_u_busRoutes': '(条)',
    '$gh_l1_n_busStations': '规划站点数',
    '$gh_l1_u_busStations': '(个)',
    '$gh_l2_title1': '区域规划',
    '$gh_l2_title2': 'Area',
    '$gh_l2_title3': 'A 区',
    '$gh_l2_name1': '建筑用地',
    '$gh_l2_name2': '绿化用地',
    '$gh_l2_name3': '居住用地',
    '$gh_l2_name4': '商业用地',
    '$gh_l2_name5': '交通用地',
    '$gh_l2_name6': '用水用地',
    '$gh_r1_title1': '用地规划',
    '$gh_r1_title2': 'Land',
    '$gh_r1_n_building': '建筑用地',
    '$gh_r1_n_virescence': '绿化用地',
    '$gh_r1_n_live': '居民用地',
    '$gh_r1_n_business': '商业用地',
    '$gh_r1_n_traffic': '交通用地',
    '$gh_r1_n_water': '水利用地',
    '$gh_r2_title1': '设施规划',
    '$gh_r2_title2': 'Facilities',
    '$gh_r2_n_name1': '停车场',
    '$gh_r2_n_name2': '消防设施',
    '$gh_r2_n_name3': '健身场地',
    '$gh_r2_n_name4': '摄像头',
    '$gh_r2_n_name5': '照明路灯',
    '$gh_r3_title1': '管网规划',
    '$gh_r3_title2': 'Pipe',
    '$gh_r3_n_title': '检查井',
    '$gh_r3_n_unit': '(米)',
    '$gh_r3_n_unit2': '个',
}
// 园区建设
const js = {
    '$js_menu_button_ly': '楼宇建设',
    '$js_menu_button_xm': '项目情况',
    '$js_l1_title1': '建设进度',
    '$js_l1_title2': 'Progress',
    '$js_l1_n_name1': '园区建设总进度',
    '$js_l1_n_name2': '商场建设进度',
    '$js_l1_n_name3': '楼宇建设进度',
    '$js_l1_n_name4': '道路建设进度',
    '$js_l1_n_name5': '配套设施建设进度',
    '$js_l2_title1': '建设详情',
    '$js_l2_title2': 'Detail',
    '$js_l2_n_name1': '区域',
    '$js_l2_n_name2': '楼宇',
    '$js_l2_n_name3': '建设面积',
    '$js_l2_n_name4': '进度',
    '$js_l2_n_name5': 'A区',
    '$js_l2_n_name6': 'B区',
    '$js_l3_title1': '施工项目',
    '$js_l3_title2': 'Project',
    '$js_l3_unit': '(个)',
    '$js_l3_btn_text1': '月',
    '$js_l3_btn_text2': '日',
    '$js_r1_title1': '项目概况',
    '$js_r1_title2': 'Situation',
    '$js_r1_name1': '普通项目',
    '$js_r1_name2': '一般项目',
    '$js_r1_name3': '重点项目',
    '$js_r1_name4': '在建项目',
    '$js_r1_name5': '已建项目',
    '$js_r1_name6': '待建项目',
    '$js_r2_title1': '管网建设',
    '$js_r2_title2': 'Situation',
    '$js_r2_n_name1': '一级管网',
    '$js_r2_n_name2': '二级管网',
    '$js_r2_n_name3': '支管网',
    '$js_r2_n_name4': '污水管网',
    '$js_r2_n_name5': '检查井',
    '$js_r3_title1': '资源使用',
    '$js_r3_title2': 'Resources',
    '$js_r3_name1': '混凝土',
    '$js_r3_name2': '水泥',
    '$js_r3_name3': '沙土',
    '$js_r3_name4': '钢筋',
}

// 园区招商
const zs = {
    '$zs_menu_button_zlqk': '租赁情况',
    '$zs_menu_button_ggw': '广告位',
    '$zs_menu_button_tcc': '停车场',
    '$zs_menu_button_yqfw': '园区服务 POI',
    '$zs_l1_title1': '园区现状',
    '$zs_l1_title2': 'Situation',
    '$zs_l1_n_area': '园区总面积',
    '$zs_l1_n_useArea': '自用面积',
    '$zs_l1_n_rentedArea': '已出租面积',
    '$zs_l1_n_notRentedArea': '待出租面积',
    '$zs_l2_title1': '区域租赁',
    '$zs_l2_title2': 'Lease',
    '$zs_l2_zone': 'A区',
    '$zs_l2_zmj': '总面积',
    '$zs_l2_zymj': '自用面积',
    '$zs_l2_zhuymj': '租用面积',
    '$zs_l2_yczmj': '已出租面积',
    '$zs_l2_wczmj': '未出租面积',
    '$zs_r1_title1': '入驻企业',
    '$zs_r1_title2': 'Enterprise',
    '$zs_r1_n_name1': '企业名称',
    '$zs_r1_n_name2': '企业法人',
    '$zs_r1_n_name3': '企业规模',
    '$zs_r1_n_name4': '企业面积',
    '$zs_r2_title1': '园区租赁',
    '$zs_r2_title2': 'Lease',
    '$zs_r2_n_name1': '自用面积',
    '$zs_r2_n_name2': '已租面积',
    '$zs_r2_n_name3': '待租面积',
    '$zs_r3_title1': '产值税收',
    '$zs_r3_title2': 'Revenue',
    '$zs_r3_n_name1': '产值',
    '$zs_r3_n_name2': '税收',
    '$zs_r4_title1': '租赁价位',
    '$zs_r4_title2': 'Price',
    '$zs_r4_n_name1': '租赁价格',
}

// 原区运营
const yy = {
    '$yy_menu_button_rstj': '人数统计',
    '$yy_menu_button_yye': '营业额',
    '$yy_menu_button_zdqy': '重点企业',
    '$yy_l1_title1': '园区环境',
    '$yy_l1_title2': 'Environment',
    '$yy_l1_n_temperature': '温度',
    '$yy_l1_n_humidity': '湿度',
    '$yy_l1_n_pm': '颗粒物',
    '$yy_l2_title1': '运营总览',
    '$yy_l2_title2': 'Operate',
    '$yy_l2_n_area': '园区总面积',
    '$yy_l2_n_rentalArea': '出租面积',
    '$yy_l2_n_occupancyRate': '企业入住率',
    '$yy_l2_n_vacancyRate': '空置率',
    '$yy_l3_title1': '园区企业',
    '$yy_l3_title2': 'Enterprise',
    '$yy_l3_tj_name1': '注册企业数：',
    '$yy_l3_tj_name2': '入住企业数：',
    '$yy_l3_lx_name1': '企业类型',
    '$yy_l3_lx_name2': '行业类型',
    '$yy_r1_title1': '园区设施',
    '$yy_r1_title2': 'Facility',
    '$yy_r1_n_title1': '摄像头',
    '$yy_r1_n_title2': '卡口1',
    '$yy_r1_n_title3': '卡口2',
    '$yy_r1_n_title4': '卡口3',
    '$yy_r1_n_cameraOnline': '在线数',
    '$yy_r1_n_cameraOffline': '离线数',
    '$yy_r1_n_cameraAlarm': '告警个数：',
    '$yy_r1_n_value1': '正常',
    '$yy_r1_n_value2': '拥堵',
    '$yy_r1_n_value3': '正常',
    '$yy_r2_title1': '车位统计',
    '$yy_r2_title2': 'Parking',
    '$yy_r2_n_title1': '园区总车位',
    '$yy_r2_n_title2': '常规车型车位',
    '$yy_r2_n_title3': '新能源车车位',
    '$yy_r2_n_used': '已用车位',
    '$yy_r2_n_free': '空闲车位',
    '$yy_r2_n_normalCarTotal': '总车位',
    '$yy_r2_n_normalCarFree': '空闲车位',
    '$yy_r2_n_newEnergyCarTotal': '总车位',
    '$yy_r2_n_newEnergyCarFree': '空闲车位',
    '$yy_r3_title1': '车辆进出',
    '$yy_r3_title2': 'Vehicle Access',
    '$yy_r3_unit': '（万）',
    '$yy_r3_name1': '进',
    '$yy_r3_name2': '出',
}

// 园区楼宇
const ly = {
    '$ly_menu_button_dtxt': '电梯系统',
    '$ly_menu_button_zmxt': '照明系统',
    '$ly_menu_button_xfxt': '消防系统',
    '$ly_menu_button_afxt': '安防系统',
    '$ly_menu_button_hjyktxt': '环境与空调系统',
    '$ly_l1_title1': '楼宇信息',
    '$ly_l1_title2': 'Building Information',
    '$ly_l1_sub_title': '楼宇简介',
    '$ly_l1_airQuality': '空气质量',
    '$ly_l1_n_airQuality': '良好',
    '$ly_l1_n_peopleOutIn': '人员进出',
    '$ly_l1_n_ele': '用电',
    '$ly_l1_n_water': '用水',
    '$ly_l1_u_water': '(万吨)',
    '$ly_l2_title1': '人员出入',
    '$ly_l2_title2': 'Staff',
    '$ly_l2_unit': '（人）',
    '$ly_l2_name1': '进',
    '$ly_l2_name2': '出',
    '$ly_l3_title1': '出入方式',
    '$ly_l3_title2': 'Approach',
    '$ly_l3_name1': '人脸扫描',
    '$ly_l3_name2': '微信预约',
    '$ly_l3_name3': 'IC卡',
    '$ly_l3_value1': '30%  55人',
    '$ly_l3_value2': '30%   55人',
    '$ly_l3_value3': '40%    30人',
    '$ly_r1_title1': '能耗分析',
    '$ly_r1_title2': 'Energy Analysis',
    '$ly_r1_n_totalEnergy': '总能耗',
    '$ly_r1_n_energyRatio': '能效比',
    '$ly_r1_n_totalLoad': '总负荷',
    '$ly_r2_title1': '实时人员',
    '$ly_r2_title2': 'Real Time Staff',
    '$ly_r2_n_totalPopulation': '园区总人数',
    '$ly_r2_n_name1': '员工',
    '$ly_r2_n_name2': '安保',
    '$ly_r2_n_name3': '访客',
    '$ly_r2_n_unit': '人',
    '$ly_r3_title1': '人流量分析',
    '$ly_r3_title2': 'Flow Analysis',
    '$ly_r3_n_staff': '就业人数',
    '$ly_r3_n_flow': '实时流量',
    '$ly_r3_unit': '（人）',
}
// 园区楼宇-电梯
const ly_dt = {
    '$ly_dt_l1_title1': '电梯运行',
    '$ly_dt_l1_title2': 'Elevator',
    '$ly_dt_l1_title3': '电梯监控视频',
    '$ly_dt_l1_name1': '正常',
    '$ly_dt_l1_name2': '故障',
    '$ly_dt_l1_elevator1': '1#电梯',
    '$ly_dt_l1_elevator2': '2#电梯',
    '$ly_dt_l1_elevator3': '3#电梯',
    '$ly_dt_l1_elevator4': '4#电梯',
    '$ly_dt_r1_title1': '累计运行',
    '$ly_dt_r1_title2': 'Total Work',
    '$ly_dt_r1_panel_title1': '运行里程',
    '$ly_dt_r1_panel_util1': '千米',
    '$ly_dt_r1_panel_title2': '载人数量',
    '$ly_dt_r1_panel_util2': '千人',
    '$ly_dt_r1_panel_title3': '开关门次数',
    '$ly_dt_r1_panel_util3': '次',
    '$ly_dt_r1_panel_title4': '高峰等梯时间',
    '$ly_dt_r1_panel_title5': '故障次数',
    '$ly_dt_r1_panel_util5': '次',
    '$ly_dt_r1_panel_title6': '检查次数',
    '$ly_dt_r1_panel_util6': '次',
    '$ly_dt_r2_title1': '设备运行',
    '$ly_dt_r2_title2': 'Equipment Operation',
    '$ly_dt_r2_panel1_name': '常规电梯总数',
    '$ly_dt_r2_panel1_n_runNumber': '运行数',
    '$ly_dt_r2_panel1_n_stopNumber': '停用数',
    '$ly_dt_r2_panel1_n_faultNumber': '故障数',
    '$ly_dt_r2_panel2_name': '消防电梯总数',
    '$ly_dt_r2_panel2_n_runNumber': '运行数',
    '$ly_dt_r2_panel2_n_stopNumber': '停用数',
    '$ly_dt_r2_panel2_n_faultNumber': '故障数',
    '$ly_dt_r3_title1': '电梯报警',
    '$ly_dt_r3_title2': 'Warning',
    '$ly_dt_r3_chart_title': '本月报警趋势图',
    '$ly_dt_r3_chart_unit': '（次）',
}
// 园区楼宇-照明
const ly_zm = {
    '$ly_zm_l1_title1': '灯光控制',
    '$ly_zm_l1_title2': 'Lighting Control',
    '$ly_zm_l1_name': '第一层',
    '$ly_zm_l1_model1': '上班模式',
    '$ly_zm_l1_model2': '下班模式',
    '$ly_zm_l1_model3': '休息模式',
    '$ly_zm_l1_n_total': '总计',
    '$ly_zm_l1_n_openNumber': '状态-开',
    '$ly_zm_l1_n_closeNumber': '休息模式',
    '$ly_zm_l2_title1': '环境照度',
    '$ly_zm_l2_title2': 'Environment',
    '$ly_zm_l2_panel_title': '本日环境照度趋势图',
    '$ly_zm_l2_panel_name': '当前环境照度',
    '$ly_zm_l3_title1': '环境工况',
    '$ly_zm_l3_title2': 'Environment Working',
    '$ly_zm_l3_panel_name1': '区域',
    '$ly_zm_l3_panel_name2': '传感器',
    '$ly_zm_l3_panel_name3': '照度值',
    '$ly_zm_r1_title1': '照明能耗',
    '$ly_zm_r1_title2': 'Light Energy',
    '$ly_zm_r1_chart_title': '本周照明能耗趋势图',
    '$ly_zm_r1_chart_unit': '（度）',
    '$ly_zm_r2_title1': '室内照明',
    '$ly_zm_r2_title2': 'Indoor Lighting',
    '$ly_zm_r2_button1': '室内照明',
    '$ly_zm_r2_button2': '路灯照明',
    '$ly_zm_r2_model': '运行模式：白天',
    '$ly_zm_r2_n_lightTotal': '灯总数',
    '$ly_zm_r2_n_lightOpenNumber': '灯开数',
    '$ly_zm_r2_n_lightCloseNumber': '灯关数',
    '$ly_zm_r2_n_name1': '室外照明监测点',
    '$ly_zm_r2_n_name2': '运行模式',
    '$ly_zm_r2_n_name3': '运行状态',
    '$ly_zm_r2_n_item1': '车库',
    '$ly_zm_r2_n_item2': '入户大堂',
    '$ly_zm_r2_n_item3': '公共区域',
    '$ly_zm_r2_n_status1': '正常',
    '$ly_zm_r2_n_status2': '故障',
    '$ly_zm_r2_n_status3': '停用',
    '$ly_zm_r3_title1': '电梯报警',
    '$ly_zm_r3_title2': 'Elevator Warning',
    '$ly_zm_r3_n_number': '报警数：',
}
// 园区楼宇-消防
const ly_xf = {
    '$ly_xf_l1_title1': '消防运行',
    '$ly_xf_l1_title2': 'Fire Fighting Operation',
    '$ly_xf_l1_n_fireEngine': '消防主机',
    '$ly_xf_l1_n_status': '运行正常',
    '$ly_xf_l1_n_time': '上次复位时间',
    '$ly_xf_l1_time': '2019-07-18',
    '$ly_xf_l1_p2_n_firePath': '消防通道',
    '$ly_xf_l1_p2_n_status': '运行正常',
    '$ly_xf_l1_p2_n_time': '上次复位时间',
    '$ly_xf_l1_p2_time': '2019-07-18',
    '$ly_xf_l1_p3_title': '烟感',
    '$ly_xf_l1_p3_unit': '个',
    '$ly_xf_l1_p3_item1_name': '运行数量',
    '$ly_xf_l1_p3_item1_unit': '（个）',
    '$ly_xf_l1_p3_item2_name': '离线数量',
    '$ly_xf_l1_p3_item2_unit': '（个）',
    '$ly_xf_l1_p3_item3_name': '故障数量',
    '$ly_xf_l1_p3_item3_unit': '（个）',
    '$ly_xf_l1_p4_title': '电气火灾',
    '$ly_xf_l1_p4_unit': '个',
    '$ly_xf_l1_p4_item1_name': '运行数量',
    '$ly_xf_l1_p4_item1_unit': '（个）',
    '$ly_xf_l1_p4_item2_name': '离线数量',
    '$ly_xf_l1_p4_item2_unit': '（个）',
    '$ly_xf_l1_p4_item3_name': '故障数量',
    '$ly_xf_l1_p4_item3_unit': '（个）',
    '$ly_xf_l2_title1': '高危火险',
    '$ly_xf_l2_title2': 'High Risk Fire Insurance',
    '$ly_xf_r1_title1': '消防主机',
    '$ly_xf_r1_title2': 'Fire Engine',
    '$ly_xf_r1_p1_title': '消防主机监测',
    '$ly_xf_r1_p1_n_airQuality': '空气质量',
    '$ly_xf_r1_p1_status': '正常',
    '$ly_xf_r1_p1_n_time': '上次复位时间',
    '$ly_xf_r1_p2_text': '消防通道监测',
    '$ly_xf_r1_p2_n_status': '当前开关状态',
    '$ly_xf_r1_p2_status': '关闭',
    '$ly_xf_r1_p2_n_time': '最后检查时间',
    '$ly_xf_r2_title1': '烟感器运行',
    '$ly_xf_r2_title2': 'Smoke Sensor',
    '$ly_xf_r2_n_total': '当前烟感总数',
    '$ly_xf_r2_n_online': '其中在线数',
    '$ly_xf_r2_button_text': '查看报警趋势',
    '$ly_xf_r3_title1': '消防报警',
    '$ly_xf_r3_title2': 'Fire Alarm',
    '$ly_xf_r3_name1': '电气报警',
    '$ly_xf_r3_name2': '烟感报警',
    '$ly_xf_r3_name3': '手动报警',
    '$ly_xf_r3_name4': '其他',
    '$ly_xf_r4_title1': '消防水压',
    '$ly_xf_r4_title2': 'Fire Water Pressure',
    '$ly_xf_r4_name1': '正常',
    '$ly_xf_r4_name2': '异常',
    '$ly_xf_r4_name3': '离线',
}
// 园区楼宇-安防系统
const ly_af = {
    '$ly_af_floor_1': '1层',
    '$ly_af_floor_2': '2层',
    '$ly_af_floor_3': '3层',
    '$ly_af_floor_4': '4层',
    '$ly_af_floor_5': '5层',
    '$ly_af_floor_6': '6层',
    '$ly_af_floor_7': '7层',
    '$ly_af_floor_8': '8层',
    '$ly_af_floor_9': '9层',
    '$ly_af_floor_10': '10层',
    '$ly_af_floor_11': '11层',
    '$ly_af_floor_12': '12层',
    '$ly_af_floor_13': '13层',
    '$ly_af_floor_14': '14层',
    '$ly_af_floor_15': '15层',
    '$ly_af_floor_16': '16层',
    '$ly_af_floor_17': '17层',
    '$ly_af_floor_18': '18层',
    '$ly_af_r1_title1': '流量监控',
    '$ly_af_r1_title2': 'Flow',
    '$ly_af_r1_n_staff': '员工',
    '$ly_af_r1_n_visitor': '访客',
    '$ly_af_r1_n_security': '安保',
    '$ly_af_r2_title1': '当日人流',
    '$ly_af_r2_title2': 'Daily Flow Curve',
    '$ly_af_r2_unit': '（个）',
    '$ly_af_r2_info': '14:00  250人',
    '$ly_af_r2_tab1': '闸机系统',
    '$ly_af_r2_tab2': '门禁系统',
    '$ly_af_r2_tab3': '停车系统',
    '$ly_af_r2_item1': '设备总数',
    '$ly_af_r2_item2': '在线运行',
    '$ly_af_r2_item3': '报警数量',
    '$ly_af_r3_title1': '视频监控',
    '$ly_af_r3_title2': 'Video Monitoring',
    '$ly_af_r3_item1': '预防设备数',
    '$ly_af_r3_item2': '报警设备数',
    '$ly_af_r3_name1': '摄像机在线',
    '$ly_af_r3_name2': '储存器在线',
    '$ly_af_r3_name3': '解码器在线',
}
// 园区楼宇-环境与空调系统
const ly_hj = {
    '$ly_hj_l1_title1': '环境监测',
    '$ly_hj_l1_title2': 'Environment Monitoring',
    '$ly_hj_l1_n_temperature': '室内温度',
    '$ly_hj_l1_n_pm25': '室内PM2.5',
    '$ly_hj_l1_n_humidity': '湿度',
    '$ly_hj_l1_n_windSpeed': '风速',
    '$ly_hj_l2_title1': '实时室温',
    '$ly_hj_l2_title2': 'Real-time Curve',
    '$ly_hj_l3_title1': '室内环境',
    '$ly_hj_l3_title2': 'Quality Statistics',
    '$ly_hj_l3_name1': '监测点',
    '$ly_hj_l3_name2': '温度℃',
    '$ly_hj_l3_name3': '湿度%',
    '$ly_hj_l3_name4': '露点温度Td',
    '$ly_hj_l3_name5': '二氧化碳ppm',
    '$ly_hj_r1_title1': '实时监控',
    '$ly_hj_r1_title2': 'Real-time Monitoring',
    '$ly_hj_r1_p_title': '实时监控',
    '$ly_hj_r2_title1': '空调负荷',
    '$ly_hj_r2_title2': 'Air Conditioning Load',
    '$ly_hj_r2_unit1': '位数/时',
    '$ly_hj_r2_unit2': '单位： 千/kw-h',
    '$ly_hj_r3_title1': '水冷主机',
    '$ly_hj_r3_title2': 'Water Cooling',
    '$ly_hj_r3_p_status': '运行',
    '$ly_hj_r3_p_working': '制热',
    '$ly_hj_r3_p_c1Status': '启用',
    '$ly_hj_r3_p_c2Status': '启用',
    '$ly_hj_r3_p_n_power': '功率',
    '$ly_hj_r3_p_n_electricity': '电量',
    '$ly_hj_r3_p_n_working': '机组运行工况',
    '$ly_hj_r3_p_n_status': '机组运行状态',
    '$ly_hj_r3_p_n_c1Status': 'C1启用状态',
    '$ly_hj_r3_p_n_c2Status': 'C2启用状态',
    '$ly_hj_r4_title1': 'VRV 系统',
    '$ly_hj_r4_title2': 'VRV System',
    '$ly_hj_r4_p_status': '运行',
    '$ly_hj_r4_p_working': '制热',
    '$ly_hj_r4_p_c1Status': '启用',
    '$ly_hj_r4_p_c2Status': '启用',
    '$ly_hj_r4_p_n_power': '功率',
    '$ly_hj_r4_p_n_electricity': '电量',
    '$ly_hj_r4_p_n_working': '机组运行工况',
    '$ly_hj_r4_p_n_status': '机组运行状态',
    '$ly_hj_r4_p_n_c1Status': 'C1启用状态',
    '$ly_hj_r4_p_n_c2Status': 'C2启用状态',
}

// 楼宇招商3d
export const zs3d = {
    '$zs3d_lease_n_price': '平均租金：',
    '$zs3d_ad_title': '广告牌',
    '$zs3d_parking_n_total': '总车位',
    '$zs3d_parking_n_used': '已用车位',
    '$zs3d_parking_n_remain': '空闲车位',
    '$zs3d_parking_n_inNumber': '进量',
    '$zs3d_parking_n_outNumber': '出量',
    '$zs3d_parking_n_faultNumber': '异常',
}

// 园区运营3d
const yy3d = {
    '$yy3d_rstj_n_inNumber': '入楼人数',
    '$yy3d_rstj_n_outNumber': '出楼人数',
    '$yy3d_yye_name': '营业额（亿元）',
    '$yy3d_zdqy_title': '重点企业',
    '$yy3d_zdqy_name1': '企业名称',
    '$yy3d_zdqy_name2': '法人',
    '$yy3d_zdqy_name3': '规模',
}

export default {
    '$title': 'Hightopo 智慧园区智能运营中心 IOC',

    ...zl,
    ...gh,
    ...js,
    ...zs,
    ...yy,
    ...ly,
    ...ly_dt,
    ...ly_zm,
    ...ly_xf,
    ...ly_af,
    ...ly_hj,

    ...zs3d,
    ...yy3d,
}